module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/wallet-connect-logo-cf0ec53f1397690b.png"+" 400w",
        images: [{path: __webpack_public_path__ + "assets/images/wallet-connect-logo-cf0ec53f1397690b.png",width: 400,height: 400}],
        src: __webpack_public_path__ + "assets/images/wallet-connect-logo-cf0ec53f1397690b.png",
        toString: function(){return __webpack_public_path__ + "assets/images/wallet-connect-logo-cf0ec53f1397690b.png"},
        
        width: 400,
        height: 400
      }